import "../../styles/sidebar.scss";
import { useContext } from "react";
import { variableManager } from "../../context-api/VariableContex";
import { useLocation, useNavigate } from "react-router-dom";
import { KycManager } from "../../context-api/KycContext";
import coming_soon from "../../icons/coming-soon.png";
import * as Icon from "iconsax-react";

export default function Sidebar() {
  const { setBtnPay, user } = useContext(variableManager);
  const {
    setLogoutPrompt,
    showSidebar,
    initSidebarItem,
    currentSidebarItem,
    setCurrentSidebarItem,
    initPayModal,
    setPayModalShow,
  } = useContext(KycManager);
  const navigate = useNavigate();

  const { pathname } = useLocation();

  // const sideBarList = [
  //   {
  //     item: "Dashboard",
  //     icon: (
  //       <svg
  //         width="24"
  //         height="24"
  //         viewBox="0 0 24 24"
  //         fill="none"
  //         xmlns="http://www.w3.org/2000/svg"
  //       >
  //         <path
  //           d="M12 18V15"
  //           stroke="#292929"
  //           strokeWidth="1.5"
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //         />
  //         <path
  //           d="M10.07 2.82009L3.14002 8.37009C2.36002 8.99009 1.86002 10.3001 2.03002 11.2801L3.36002 19.2401C3.60002 20.6601 4.96002 21.8101 6.40002 21.8101H17.6C19.03 21.8101 20.4 20.6501 20.64 19.2401L21.97 11.2801C22.13 10.3001 21.63 8.99009 20.86 8.37009L13.93 2.83009C12.86 1.97009 11.13 1.97009 10.07 2.82009Z"
  //           stroke="#292929"
  //           strokeWidth="1.5"
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //         />
  //       </svg>
  //     ),
  //     link: "/user/dashboard",
  //   },

  //   {
  //     item: "Activty",
  //     icon: (
  //       <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  //         <path
  //           d="M10.4502 7.46997C10.2602 7.46997 10.0702 7.4 9.9202 7.25L6.7302 4.06L3.54019 7.25C3.25019 7.54 2.7702 7.54 2.4802 7.25C2.1902 6.96 2.1902 6.48 2.4802 6.19L6.20023 2.46997C6.34023 2.32997 6.5302 2.25 6.7302 2.25C6.9302 2.25 7.12022 2.32997 7.26022 2.46997L10.9802 6.19C11.2702 6.48 11.2702 6.96 10.9802 7.25C10.8302 7.4 10.6402 7.46997 10.4502 7.46997Z"
  //           fill="#3D4754"
  //         />
  //         <path
  //           d="M6.72998 21.75C6.31998 21.75 5.97998 21.41 5.97998 21V3C5.97998 2.59 6.31998 2.25 6.72998 2.25C7.13998 2.25 7.47998 2.59 7.47998 3V21C7.47998 21.41 7.13998 21.75 6.72998 21.75Z"
  //           fill="#3D4754"
  //         />
  //         <path
  //           d="M17.28 21.7497C17.08 21.7497 16.89 21.6698 16.75 21.5298L13.03 17.8097C12.74 17.5197 12.74 17.0397 13.03 16.7497C13.32 16.4597 13.8 16.4597 14.09 16.7497L17.28 19.9397L20.4699 16.7497C20.7599 16.4597 21.24 16.4597 21.53 16.7497C21.82 17.0397 21.82 17.5197 21.53 17.8097L17.81 21.5298C17.67 21.6698 17.47 21.7497 17.28 21.7497Z"
  //           fill="#3D4754"
  //         />
  //         <path
  //           d="M17.27 21.75C16.86 21.75 16.52 21.41 16.52 21V3C16.52 2.59 16.86 2.25 17.27 2.25C17.68 2.25 18.02 2.59 18.02 3V21C18.02 21.41 17.69 21.75 17.27 21.75Z"
  //           fill="#3D4754"
  //         />
  //       </svg>
  //     ),
  //     link: "/user/dashboard",
  //   },
  // ];

  return (
    <div
      className={
        showSidebar ? "sidebar-container" : "sidebar-container hide-sidebar"
      }
    >
      {/* <div className="switch">
        {showSidebar ? (
          <div className="close pointer" onClick={() => setShowSidebar(false)}>

            <BiCaretLeftCircle />
          </div>
        ) : (
          <div className="open pointer" onClick={() => setShowSidebar(true)}>
             <BiCaretRightCircle />
          </div>
        )}
      </div> */}

      <div className="mobile">
        <div className="header">
          <h5 style={{ userSelect: "none" }}>MAIN MENU</h5>
        </div>
        <div className="items-section">
          <div
            className={
              pathname === "/user/dashboard" ? "item active-section" : "item"
            }
            onClick={() => {
              setBtnPay(false);
              navigate("/user/dashboard");
              setCurrentSidebarItem({ ...initSidebarItem, dashboard: true });
            }}
          >
            <div className="item-icon ">
              {/* <AiFillHome className="icon"/> */}
              <div className="icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 18V15"
                    stroke="#292929"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M10.07 2.82009L3.14002 8.37009C2.36002 8.99009 1.86002 10.3001 2.03002 11.2801L3.36002 19.2401C3.60002 20.6601 4.96002 21.8101 6.40002 21.8101H17.6C19.03 21.8101 20.4 20.6501 20.64 19.2401L21.97 11.2801C22.13 10.3001 21.63 8.99009 20.86 8.37009L13.93 2.83009C12.86 1.97009 11.13 1.97009 10.07 2.82009Z"
                    stroke="#292929"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div className="item-title ">Dashboard</div>
          </div>

          <div
            className={
              pathname === "/user/dashboard/activities" &&
              !currentSidebarItem.pay &&
              !currentSidebarItem.getPaid
                ? "item active-section"
                : "item"
            }
            onClick={() => {
              setCurrentSidebarItem({ ...initSidebarItem, activity: true });
              setBtnPay(false);
              navigate("/user/dashboard/activities");
            }}
          >
            <div className="item-icon">
              {/* <RiArrowUpDownFill className="icon" /> */}
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M10.4502 7.46997C10.2602 7.46997 10.0702 7.4 9.9202 7.25L6.7302 4.06L3.54019 7.25C3.25019 7.54 2.7702 7.54 2.4802 7.25C2.1902 6.96 2.1902 6.48 2.4802 6.19L6.20023 2.46997C6.34023 2.32997 6.5302 2.25 6.7302 2.25C6.9302 2.25 7.12022 2.32997 7.26022 2.46997L10.9802 6.19C11.2702 6.48 11.2702 6.96 10.9802 7.25C10.8302 7.4 10.6402 7.46997 10.4502 7.46997Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M6.72998 21.75C6.31998 21.75 5.97998 21.41 5.97998 21V3C5.97998 2.59 6.31998 2.25 6.72998 2.25C7.13998 2.25 7.47998 2.59 7.47998 3V21C7.47998 21.41 7.13998 21.75 6.72998 21.75Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M17.28 21.7497C17.08 21.7497 16.89 21.6698 16.75 21.5298L13.03 17.8097C12.74 17.5197 12.74 17.0397 13.03 16.7497C13.32 16.4597 13.8 16.4597 14.09 16.7497L17.28 19.9397L20.4699 16.7497C20.7599 16.4597 21.24 16.4597 21.53 16.7497C21.82 17.0397 21.82 17.5197 21.53 17.8097L17.81 21.5298C17.67 21.6698 17.47 21.7497 17.28 21.7497Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M17.27 21.75C16.86 21.75 16.52 21.41 16.52 21V3C16.52 2.59 16.86 2.25 17.27 2.25C17.68 2.25 18.02 2.59 18.02 3V21C18.02 21.41 17.69 21.75 17.27 21.75Z"
                    fill="#3D4754"
                  />
                </svg>
              </div>
            </div>
            <div className="item-title activity">
              Activity
              {/* <AiOutlineDown /> */}
            </div>
          </div>

          <div
            className={
              pathname === "/user/dashboard/activities" &&
              currentSidebarItem.pay
                ? "item active-section"
                : "item"
            }
            onClick={(e) => {
              setCurrentSidebarItem({ ...initSidebarItem, pay: true });
              setBtnPay(true);
              navigate("/user/dashboard/activities");
            }}
          >
            <div className="item-icon ">
              {/* <BsGridFill className="icon" /> */}
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M19.77 13.75H15.73C13.72 13.75 12.75 12.82 12.75 10.9V4.1C12.75 2.18 13.73 1.25 15.73 1.25H19.77C21.78 1.25 22.75 2.18 22.75 4.1V10.9C22.75 12.82 21.77 13.75 19.77 13.75ZM15.73 2.75C14.46 2.75 14.25 3.09 14.25 4.1V10.9C14.25 11.91 14.46 12.25 15.73 12.25H19.77C21.04 12.25 21.25 11.91 21.25 10.9V4.1C21.25 3.09 21.04 2.75 19.77 2.75H15.73Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M19.77 22.75H15.73C13.72 22.75 12.75 21.82 12.75 19.9V18.1C12.75 16.18 13.73 15.25 15.73 15.25H19.77C21.78 15.25 22.75 16.18 22.75 18.1V19.9C22.75 21.82 21.77 22.75 19.77 22.75ZM15.73 16.75C14.46 16.75 14.25 17.09 14.25 18.1V19.9C14.25 20.91 14.46 21.25 15.73 21.25H19.77C21.04 21.25 21.25 20.91 21.25 19.9V18.1C21.25 17.09 21.04 16.75 19.77 16.75H15.73Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M8.27 22.75H4.23C2.22 22.75 1.25 21.82 1.25 19.9V13.1C1.25 11.18 2.23 10.25 4.23 10.25H8.27C10.28 10.25 11.25 11.18 11.25 13.1V19.9C11.25 21.82 10.27 22.75 8.27 22.75ZM4.23 11.75C2.96 11.75 2.75 12.09 2.75 13.1V19.9C2.75 20.91 2.96 21.25 4.23 21.25H8.27C9.54 21.25 9.75 20.91 9.75 19.9V13.1C9.75 12.09 9.54 11.75 8.27 11.75H4.23Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M8.27 8.75H4.23C2.22 8.75 1.25 7.82 1.25 5.9V4.1C1.25 2.18 2.23 1.25 4.23 1.25H8.27C10.28 1.25 11.25 2.18 11.25 4.1V5.9C11.25 7.82 10.27 8.75 8.27 8.75ZM4.23 2.75C2.96 2.75 2.75 3.09 2.75 4.1V5.9C2.75 6.91 2.96 7.25 4.23 7.25H8.27C9.54 7.25 9.75 6.91 9.75 5.9V4.1C9.75 3.09 9.54 2.75 8.27 2.75H4.23Z"
                    fill="#3D4754"
                  />
                </svg>
              </div>
            </div>
            <div className="item-title ">Pay</div>
          </div>

          <div
            className={
              pathname === "/user/dashboard/activities" &&
              currentSidebarItem.getPaid
                ? "item active-section"
                : "item"
            }
            onClick={(e) => {
              setCurrentSidebarItem({ ...initSidebarItem, getPaid: true });
              setBtnPay(false);
              navigate("/user/dashboard/activities");
              if (user.Accounts[0]) {
                // setModalShowAccount(true)
                setPayModalShow({ ...initPayModal, receiveMethod: true });
              }
            }}
          >
            <div className="item-icon ">
              {/* <AiFillDollarCircle className="icon dollar" /> */}
              <div className="icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.6663 13.9997C25.6663 20.4397 20.4397 25.6663 13.9997 25.6663C7.55967 25.6663 2.33301 20.4397 2.33301 13.9997C2.33301 7.55967 7.55967 2.33301 13.9997 2.33301"
                    stroke="#474747"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.75 17.5V9.51708C11.75 9.34742 11.7982 9.18255 11.8872 9.04836C11.9762 8.91418 12.1009 8.81827 12.2416 8.77571C12.3824 8.73315 12.5313 8.74634 12.6649 8.81322C12.7986 8.8801 12.9094 8.99688 12.98 9.14521L16.77 17.1048C16.8406 17.2531 16.9514 17.3699 17.0851 17.4368C17.2187 17.5037 17.3676 17.5169 17.5084 17.4743C17.6491 17.4317 17.7738 17.3358 17.8628 17.2016C17.9518 17.0674 18 16.9026 18 16.7329V8.75M10.5 11.6667H19.25M10.5 14.5833H19.25"
                    stroke="#474747"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21.6054 1.71316L21.5464 6.37945L26.2126 6.43848"
                    stroke="#32D16D"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M27.4537 0.620258L21.547 6.37934"
                    stroke="#32D16D"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div className="item-title ">Get Paid</div>
          </div>

          {/* <div
            className={
              currentSidebarItem.subAccount ? "item active-section" : "item"
            }
            onClick={(e) => {
              setCurrentSidebarItem({ ...initSidebarItem, subAccount: true });
              setBtnPay(false);
              navigate("/user/dashboard/sub-accounts");

            }}
          >
            <div className="item-icon ">
              <div className="icon">
                <Icon.Profile2User />
              </div>
            </div>
            <div className="item-title ">Sub Accounts</div>
          </div> */}

          {/* <div
            className={
              pathname === "/user/dashboard/invoices"
                ? "item active-section"
                : "item"
            }
            onClick={(e) => {
              setCurrentSidebarItem({ ...initSidebarItem, invoice: true });
              setBtnPay(false);
              navigate("/user/dashboard/invoices");

            }}
          >
            <div className="item-icon ">
              <div className="icon">
                <Icon.Ticket />
              </div>
            </div>
            <div className="item-title ">Invoices</div>
          </div> */}

          <div
            className={currentSidebarItem.pos ? "item active-section" : "item"}
            onClick={(e) => {
              setCurrentSidebarItem({ ...initSidebarItem, pos: true });
              navigate("/user/dashboard/pos");
            }}
          >
            <div className="item-icon ">
              {/* <MdAddBusiness className="icon dollar" /> */}
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M16.5 8.6303C16.09 8.6303 15.75 8.2903 15.75 7.8803V6.5003C15.75 5.4503 15.3 4.4303 14.52 3.7203C13.73 3.0003 12.71 2.6703 11.63 2.7703C9.83 2.9403 8.25 4.7803 8.25 6.7003V7.6703C8.25 8.0803 7.91 8.4203 7.5 8.4203C7.09 8.4203 6.75 8.0803 6.75 7.6703V6.6903C6.75 4.0003 8.92 1.5203 11.49 1.2703C12.99 1.1303 14.43 1.6003 15.53 2.6103C16.62 3.6003 17.25 5.0203 17.25 6.5003V7.8803C17.25 8.2903 16.91 8.6303 16.5 8.6303Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M15.0001 22.75H9.00006C4.38006 22.75 3.52006 20.6 3.30006 18.51L2.55006 12.52C2.44006 11.44 2.40006 9.89 3.45006 8.73C4.35006 7.73 5.84006 7.25 8.00006 7.25H16.0001C18.1701 7.25 19.6601 7.74 20.5501 8.73C21.5901 9.89 21.5601 11.44 21.4501 12.5L20.7001 18.51C20.4801 20.6 19.6201 22.75 15.0001 22.75ZM8.00006 8.75C6.31006 8.75 5.15006 9.08 4.56006 9.74C4.07006 10.28 3.91006 11.11 4.04006 12.35L4.79006 18.34C4.96006 19.94 5.40006 21.26 9.00006 21.26H15.0001C18.6001 21.26 19.0401 19.95 19.2101 18.36L19.9601 12.35C20.0901 11.13 19.9301 10.3 19.4401 9.75C18.8501 9.08 17.6901 8.75 16.0001 8.75H8.00006Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M15.4199 13.1504C14.8599 13.1504 14.4099 12.7004 14.4099 12.1504C14.4099 11.6004 14.8599 11.1504 15.4099 11.1504C15.9599 11.1504 16.4099 11.6004 16.4099 12.1504C16.4099 12.7004 15.9699 13.1504 15.4199 13.1504Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M8.41991 13.1504C7.85991 13.1504 7.40991 12.7004 7.40991 12.1504C7.40991 11.6004 7.85991 11.1504 8.40991 11.1504C8.95991 11.1504 9.40991 11.6004 9.40991 12.1504C9.40991 12.7004 8.96991 13.1504 8.41991 13.1504Z"
                    fill="#3D4754"
                  />
                </svg>
              </div>
            </div>
            <div className="item-title ">
              {/* Business Tools */}
              POS Terminal
            </div>
          </div>

          {/* <div className="item ">
                    <div className="item-icon ">
                        <div className="icon">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" >
                                <path d="M19.0301 14.97C19.0301 16.26 20.0901 17.31 21.3801 17.31C21.3801 21.06 20.4401 22 16.6901 22H7.31012C3.56012 22 2.62012 21.06 2.62012 17.31V16.85C3.91012 16.85 4.97012 15.79 4.97012 14.5C4.97012 13.21 3.91012 12.15 2.62012 12.15V11.69C2.63012 7.94 3.56012 7 7.31012 7H16.6801C20.4301 7 21.3701 7.94 21.3701 11.69V12.63" stroke="#3D4754" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M16.33 6.99984H7.23999L10.17 4.06984C12.56 1.67984 13.76 1.67984 16.15 4.06984L16.75 4.66984C16.12 5.29984 15.97 6.22984 16.33 6.99984Z" stroke="#3D4754" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M10 7L10 22" stroke="#3D4754" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="5 5" />
                            </svg>

                        </div>
                    </div>
                    <div className="item-title ">
                        Report Dispute
                    </div>
                </div> */}

          <div
            className={
              pathname === "/user/dashboard/support"
                ? "item active-section"
                : "item"
            }
            onClick={(e) => {
              setCurrentSidebarItem({ ...initSidebarItem, support: true });
              navigate("/user/dashboard/support");
            }}
          >
            <div className="item-icon ">
              {/* <BiSupport className="icon dollar" /> */}
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7.25999 18.8898C7.17999 18.8898 7.1 18.8798 7.02 18.8698C6.42 18.7898 5.91 18.4098 5.66 17.8698L4.39999 15.0997C2.39999 13.6197 1.25 11.4098 1.25 9.00977C1.25 4.73977 4.95 1.25977 9.5 1.25977C12.71 1.25977 15.64 3.01976 16.97 5.74976C17.48 6.75976 17.75 7.85977 17.75 9.00977C17.75 13.1698 14.24 16.5798 9.86 16.7498L8.60001 18.2698C8.26001 18.6598 7.76999 18.8898 7.25999 18.8898ZM9.5 2.74976C5.78 2.74976 2.75 5.54976 2.75 8.99976C2.75 10.9698 3.72999 12.7897 5.42999 13.9897C5.53999 14.0697 5.62999 14.1697 5.67999 14.2897L7.02 17.2397C7.07 17.3497 7.17 17.3798 7.22 17.3798C7.27 17.3898 7.37 17.3797 7.44 17.2997L8.92 15.5198C9.06 15.3498 9.27 15.2498 9.5 15.2498C13.22 15.2498 16.25 12.4498 16.25 8.99976C16.25 8.08976 16.04 7.21973 15.63 6.40973C14.55 4.17973 12.14 2.74976 9.5 2.74976Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M16.7401 22.7501C16.2201 22.7501 15.7401 22.5201 15.4001 22.1201L14.1401 20.6101C11.7201 20.5101 9.44008 19.4001 7.98008 17.6001C7.75008 17.3201 7.76009 16.9201 7.99009 16.6501L8.92008 15.5301C9.06008 15.3601 9.27008 15.2601 9.50008 15.2601C13.2201 15.2601 16.2501 12.4601 16.2501 9.01012C16.2501 8.10012 16.0401 7.23009 15.6301 6.42009C15.5001 6.16009 15.5301 5.8501 15.7101 5.6201C15.8901 5.3901 16.1901 5.29008 16.4701 5.35008C20.1701 6.20008 22.7501 9.2901 22.7501 12.8701C22.7501 15.2701 21.6001 17.4801 19.6001 18.9601L18.3401 21.7301C18.0801 22.2901 17.5701 22.6701 16.9601 22.7401C16.8901 22.7501 16.8101 22.7501 16.7401 22.7501ZM9.56008 17.1001C10.8101 18.3701 12.6101 19.1101 14.5001 19.1101C14.7201 19.1101 14.9301 19.2101 15.0801 19.3801L16.5601 21.1601C16.6301 21.2501 16.7201 21.2601 16.7801 21.2501C16.8201 21.2501 16.9301 21.2201 16.9901 21.1001L18.3301 18.1501C18.3901 18.0301 18.4701 17.9201 18.5801 17.8501C20.2801 16.6501 21.2601 14.8301 21.2601 12.8601C21.2601 10.4601 19.7901 8.33014 17.5501 7.28014C17.6901 7.84014 17.7601 8.41011 17.7601 9.00011C17.7601 13.1601 14.2501 16.5701 9.87008 16.7401L9.56008 17.1001Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M12 9.75H7C6.59 9.75 6.25 9.41 6.25 9C6.25 8.59 6.59 8.25 7 8.25H12C12.41 8.25 12.75 8.59 12.75 9C12.75 9.41 12.41 9.75 12 9.75Z"
                    fill="#3D4754"
                  />
                </svg>
              </div>
            </div>
            <div className="item-title ">Support</div>
          </div>

          <div
            className={
              pathname === "/user/dashboard/settings"
                ? "item active-section"
                : "item"
            }
          >
            <div className="item-icon ">
              {/* <AiFillSetting className="icon dollar" /> */}
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M15.21 22.1903C15 22.1903 14.79 22.1603 14.58 22.1103C13.96 21.9403 13.44 21.5503 13.11 21.0003L12.99 20.8003C12.4 19.7803 11.59 19.7803 11 20.8003L10.89 20.9903C10.56 21.5503 10.04 21.9503 9.42 22.1103C8.79 22.2803 8.14 22.1903 7.59 21.8603L5.87 20.8703C5.26 20.5203 4.82 19.9503 4.63 19.2603C4.45 18.5703 4.54 17.8603 4.89 17.2503C5.18 16.7403 5.26 16.2803 5.09 15.9903C4.92 15.7003 4.49 15.5303 3.9 15.5303C2.44 15.5303 1.25 14.3403 1.25 12.8803V11.1203C1.25 9.66029 2.44 8.47029 3.9 8.47029C4.49 8.47029 4.92 8.30029 5.09 8.01029C5.26 7.72029 5.19 7.26029 4.89 6.75029C4.54 6.14029 4.45 5.42029 4.63 4.74029C4.81 4.05029 5.25 3.48029 5.87 3.13029L7.6 2.14029C8.73 1.47029 10.22 1.86029 10.9 3.01029L11.02 3.21029C11.61 4.23029 12.42 4.23029 13.01 3.21029L13.12 3.02029C13.8 1.86029 15.29 1.47029 16.43 2.15029L18.15 3.14029C18.76 3.49029 19.2 4.06029 19.39 4.75029C19.57 5.44029 19.48 6.15029 19.13 6.76029C18.84 7.27029 18.76 7.73029 18.93 8.02029C19.1 8.31029 19.53 8.48029 20.12 8.48029C21.58 8.48029 22.77 9.67029 22.77 11.1303V12.8903C22.77 14.3503 21.58 15.5403 20.12 15.5403C19.53 15.5403 19.1 15.7103 18.93 16.0003C18.76 16.2903 18.83 16.7503 19.13 17.2603C19.48 17.8703 19.58 18.5903 19.39 19.2703C19.21 19.9603 18.77 20.5303 18.15 20.8803L16.42 21.8703C16.04 22.0803 15.63 22.1903 15.21 22.1903ZM12 18.4903C12.89 18.4903 13.72 19.0503 14.29 20.0403L14.4 20.2303C14.52 20.4403 14.72 20.5903 14.96 20.6503C15.2 20.7103 15.44 20.6803 15.64 20.5603L17.37 19.5603C17.63 19.4103 17.83 19.1603 17.91 18.8603C17.99 18.5603 17.95 18.2503 17.8 17.9903C17.23 17.0103 17.16 16.0003 17.6 15.2303C18.04 14.4603 18.95 14.0203 20.09 14.0203C20.73 14.0203 21.24 13.5103 21.24 12.8703V11.1103C21.24 10.4803 20.73 9.96029 20.09 9.96029C18.95 9.96029 18.04 9.52029 17.6 8.75029C17.16 7.98029 17.23 6.97029 17.8 5.99029C17.95 5.73029 17.99 5.42029 17.91 5.12029C17.83 4.82029 17.64 4.58029 17.38 4.42029L15.65 3.43029C15.22 3.17029 14.65 3.32029 14.39 3.76029L14.28 3.95029C13.71 4.94029 12.88 5.50029 11.99 5.50029C11.1 5.50029 10.27 4.94029 9.7 3.95029L9.59 3.75029C9.34 3.33029 8.78 3.18029 8.35 3.43029L6.62 4.43029C6.36 4.58029 6.16 4.83029 6.08 5.13029C6 5.43029 6.04 5.74029 6.19 6.00029C6.76 6.98029 6.83 7.99029 6.39 8.76029C5.95 9.53029 5.04 9.97029 3.9 9.97029C3.26 9.97029 2.75 10.4803 2.75 11.1203V12.8803C2.75 13.5103 3.26 14.0303 3.9 14.0303C5.04 14.0303 5.95 14.4703 6.39 15.2403C6.83 16.0103 6.76 17.0203 6.19 18.0003C6.04 18.2603 6 18.5703 6.08 18.8703C6.16 19.1703 6.35 19.4103 6.61 19.5703L8.34 20.5603C8.55 20.6903 8.8 20.7203 9.03 20.6603C9.27 20.6003 9.47 20.4403 9.6 20.2303L9.71 20.0403C10.28 19.0603 11.11 18.4903 12 18.4903Z"
                    fill="#3D4754"
                  />
                </svg>
              </div>
            </div>
            <div
              className="item-title "
              onClick={(e) => {
                setCurrentSidebarItem({ ...initSidebarItem, settings: true });
                navigate("/user/dashboard/settings");
              }}
            >
              Settings
            </div>
          </div>
          <div
            className={
              currentSidebarItem.community ? "item active-section" : "item"
            }
          >
            <div className="item-icon ">
              {/* <MdAddBusiness className="icon dollar" /> */}
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M16.5 8.6303C16.09 8.6303 15.75 8.2903 15.75 7.8803V6.5003C15.75 5.4503 15.3 4.4303 14.52 3.7203C13.73 3.0003 12.71 2.6703 11.63 2.7703C9.83 2.9403 8.25 4.7803 8.25 6.7003V7.6703C8.25 8.0803 7.91 8.4203 7.5 8.4203C7.09 8.4203 6.75 8.0803 6.75 7.6703V6.6903C6.75 4.0003 8.92 1.5203 11.49 1.2703C12.99 1.1303 14.43 1.6003 15.53 2.6103C16.62 3.6003 17.25 5.0203 17.25 6.5003V7.8803C17.25 8.2903 16.91 8.6303 16.5 8.6303Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M15.0001 22.75H9.00006C4.38006 22.75 3.52006 20.6 3.30006 18.51L2.55006 12.52C2.44006 11.44 2.40006 9.89 3.45006 8.73C4.35006 7.73 5.84006 7.25 8.00006 7.25H16.0001C18.1701 7.25 19.6601 7.74 20.5501 8.73C21.5901 9.89 21.5601 11.44 21.4501 12.5L20.7001 18.51C20.4801 20.6 19.6201 22.75 15.0001 22.75ZM8.00006 8.75C6.31006 8.75 5.15006 9.08 4.56006 9.74C4.07006 10.28 3.91006 11.11 4.04006 12.35L4.79006 18.34C4.96006 19.94 5.40006 21.26 9.00006 21.26H15.0001C18.6001 21.26 19.0401 19.95 19.2101 18.36L19.9601 12.35C20.0901 11.13 19.9301 10.3 19.4401 9.75C18.8501 9.08 17.6901 8.75 16.0001 8.75H8.00006Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M15.4199 13.1504C14.8599 13.1504 14.4099 12.7004 14.4099 12.1504C14.4099 11.6004 14.8599 11.1504 15.4099 11.1504C15.9599 11.1504 16.4099 11.6004 16.4099 12.1504C16.4099 12.7004 15.9699 13.1504 15.4199 13.1504Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M8.41991 13.1504C7.85991 13.1504 7.40991 12.7004 7.40991 12.1504C7.40991 11.6004 7.85991 11.1504 8.40991 11.1504C8.95991 11.1504 9.40991 11.6004 9.40991 12.1504C9.40991 12.7004 8.96991 13.1504 8.41991 13.1504Z"
                    fill="#3D4754"
                  />
                </svg>
              </div>
            </div>
            <div
              className="item-title d-flex align-items-center gap-1"
              onClick={() => {
                // setCurrentSidebarItem({...initSidebarItem, community:true});
                // handleTransactionHistory()
              }}
            >
              {/* Business Tools */}
              Community
              <div className="image" style={{ width: "25px" }}>
                <img
                  src={coming_soon}
                  alt="coming soon"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>

          <div
            className={
              currentSidebarItem.logout ? "item active-section" : "item"
            }
          >
            <div className="item-icon ">
              {/* <IoIosUnlock className="icon dollar" /> */}
              <div className="icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 19.75C9.38 19.75 7.25 17.62 7.25 15C7.25 12.38 9.38 10.25 12 10.25C14.62 10.25 16.75 12.38 16.75 15C16.75 17.62 14.62 19.75 12 19.75ZM12 11.75C10.21 11.75 8.75 13.21 8.75 15C8.75 16.79 10.21 18.25 12 18.25C13.79 18.25 15.25 16.79 15.25 15C15.25 13.21 13.79 11.75 12 11.75Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M10.9999 16.7498C10.7499 16.7498 10.4999 16.6198 10.3599 16.3898C10.1499 16.0298 10.2599 15.5698 10.6199 15.3598L11.3799 14.8998C11.4599 14.8498 11.4999 14.7698 11.4999 14.6898V13.7598C11.4999 13.3498 11.8399 13.0098 12.2499 13.0098C12.6599 13.0098 12.9999 13.3398 12.9999 13.7498V14.6798C12.9999 15.2898 12.6699 15.8698 12.1499 16.1798L11.3799 16.6398C11.2699 16.7198 11.1299 16.7498 10.9999 16.7498Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M14.5037 22.5H8.50372C3.88372 22.5 3.02372 20.35 2.80372 18.26L2.05372 12.27C1.94372 11.19 1.90372 9.64 2.95372 8.48C3.85372 7.48 5.34372 7 7.50372 7H15.5037C17.6737 7 19.1637 7.49 20.0537 8.48C21.0937 9.64 21.0637 11.19 20.9537 12.25L20.2037 18.26C19.9837 20.35 19.1237 22.5 14.5037 22.5ZM7.50372 8.5C5.81372 8.5 4.65372 8.83 4.06372 9.49C3.57372 10.03 3.41372 10.86 3.54372 12.1L4.29372 18.09C4.46372 19.69 4.90372 21.01 8.50372 21.01H14.5037C18.1037 21.01 18.5437 19.7 18.7137 18.11L19.4637 12.1C19.5937 10.88 19.4337 10.05 18.9437 9.5C18.3537 8.83 17.1937 8.5 15.5037 8.5H7.50372Z"
                    fill="#3D4754"
                  />
                  <path
                    d="M16.5 8.6303C16.09 8.6303 15.75 8.2903 15.75 7.8803V6.5003C15.75 5.4503 15.3 4.4303 14.52 3.7203C13.73 3.0003 12.7 2.6703 11.63 2.7703C9.83 2.9403 8.25 4.7803 8.25 6.7003V7.6703C8.25 8.0803 7.91 8.4203 7.5 8.4203C7.09 8.4203 6.75 8.0803 6.75 7.6703V6.6903C6.75 4.0003 8.92 1.5203 11.49 1.2703C12.99 1.1303 14.43 1.6003 15.53 2.6103C16.62 3.6003 17.25 5.0203 17.25 6.5003V7.8803C17.25 8.2903 16.91 8.6303 16.5 8.6303Z"
                    fill="#3D4754"
                  />
                </svg>
              </div>
            </div>
            <div
              className="item-title "
              onClick={() => {
                setCurrentSidebarItem({ ...initSidebarItem, logout: true });
                setLogoutPrompt(true);
              }}
            >
              Logout
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
